import { ReactNode, useCallback, useState } from 'react';
import { Columns, Element, Section } from 'react-bulma-components';
import { Outlet, useNavigate } from 'react-router-dom';
import BackButton from '../../shared/back-button/back-button';
import If from '../../shared/if/if';
import BoxLayout from '../../ui/box-layout/box-layout';
import { SalesOrdersAccessStorageService } from '../sales-orders-access-storage-service';
import { TemporaryAccessSetupSteps } from './types';

const temporaryAccessSalesOrdersSessionStorageService =
  new SalesOrdersAccessStorageService();

export function AdminTemporaryAccessSetupPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState<number>(1);
  const [headerButton, setHeaderButton] = useState<ReactNode>();

  const resetData = useCallback(() => {
    temporaryAccessSalesOrdersSessionStorageService.remove();
  }, []);

  const handleBackButtonClick = useCallback(() => {
    switch (step) {
      case TemporaryAccessSetupSteps.SALES_ORDERS:
        resetData();
        navigate('/admin/temporary-access');
        break;
      case TemporaryAccessSetupSteps.USER:
        navigate('/admin/temporary-access/setup/sales-orders');
        break;
    }
  }, [navigate, resetData, step]);

  const Header = useCallback(() => {
    return (
      <Element className="p-4">
        <Section paddingless>
          <BackButton onClick={handleBackButtonClick} />
          <Columns>
            <Columns.Column>
              <h1 className="is-size-3 has-text-weight-light">
                Grant temporary support access
              </h1>
              <If condition={step === TemporaryAccessSetupSteps.SALES_ORDERS}>
                <h2 className="is-size-5 has-text-weight-light">
                  Select the Sales Orders you want to grant temporary access to.
                </h2>
              </If>
            </Columns.Column>
            <If condition={!!headerButton}>
              <Columns.Column display="flex" justifyContent="flex-end">
                {headerButton}
              </Columns.Column>
            </If>
          </Columns>
        </Section>
      </Element>
    );
  }, [handleBackButtonClick, headerButton, step]);

  return (
    <BoxLayout className="is-min-height-80 mx-10 my-4" flex header={<Header />}>
      <Outlet context={{ setStep, setHeaderButton }} />
    </BoxLayout>
  );
}

export default AdminTemporaryAccessSetupPage;
